import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectFileService {
  constructor(private readonly api: ApiService) {}

  public getFilesInKeyProjectFolder(projectId: string, parentId: string): Observable<any> {
    return this.api.httpGet('/api/projects/' + projectId + '/kpffiles?parentId=' + parentId);
  }

  public getProjectFiles(projectId: string, parentId?: any): Observable<any> {
    const query: string[] = [];
    if (parentId) {
      query.push(`parentId=${parentId}`);
    }
    return this.api.httpGet('/api/projects/' + projectId + '/files' + (query.length ? '?' + query.join('&') : ''));
  }

  public getTaskAttachments(projectId: string, parentId?: any): Observable<any> {
    return this.api.httpGet('/api/tasks/attachement/' + projectId + '/' + parentId);
  }

  public getFilesBySectionId(projectId: string, sectionId: any): Promise<any> {
    return this.api.httpGet('/api/projects/' + projectId + '/' + sectionId + '/files-tree').toPromise();
  }

  public getFilesTree(projectId: string, enableKeyProjectFiles: boolean = false): Observable<any> {
    return this.api.httpGet(
      `/api/assets/project/${projectId}/file-tree?enableKeyProjectFiles=${enableKeyProjectFiles}`
    );
  }

  public getKPFTree(projectId: string, parentId: string | null = null): Observable<any> {
    const parent: string = parentId ? `?parent=${parentId}` : '';
    return this.api.httpGet(`/api/assets/project/${projectId}/file-tree/kpf${parent}`);
  }

  public deleteFile(fileId: string, projectId: string): Observable<any> {
    return this.api.httpDelete('/api/projects/' + projectId + '/files/' + encodeURIComponent(fileId));
  }

  public getAssetFiles(
    projectId: string,
    sectionId: string,
    subsectionId: string,
    assetId: string | null = null
  ): Observable<any> {
    let url: string = `/api/projects/${projectId}/sections/${sectionId}/subsections/${subsectionId}/items/folderfiles`;
    if (assetId) {
      url += `?itemId=${assetId}`;
    }
    return this.api.httpGet(url);
  }

  public getFileInfo(projectId: string, fileId: string): Observable<any> {
    return this.api.httpGet(`/api/projects/${projectId}/storage/${fileId}/poll`);
  }
}
